module.exports = __webpack_public_path__ + "static/media/downarrow-green.c371f2c0.svg";